import { gql, useMutation } from "@apollo/client";
import { useEffect } from "react";
import { captureException } from "@sentry/react";
import { useSearchParams } from "react-router-dom";

import { AUTH_ID, AUTH_TOKEN, AUTH_WS_TOKEN, SHARD_NUMBER } from "constants";
import LoadingPage from "components/other/LoadingPage";

export default () => {
  const [searchParams] = useSearchParams();

  // const LayoutProperties = createSelector(
  //   (state) => state.Layout,
  //   (layout) => ({
  //     ipAddress: layout.ipAddress,
  //   })
  // );

  // const { ipAddress } = useSelector(LayoutProperties);

  const ipAddress = "";

  const x = searchParams.get("x");
  const y = searchParams.get("y");
  const destination = searchParams.get("destination");

  if (localStorage.getItem(AUTH_TOKEN)) {
    // user already logged in
    if (destination && destination !== "") window.location = "/" + destination;
    else window.location = "/home";
  }

  if (!x || !y) {
    window.location = "/?message=magicLoginFailed";
    return;
  }

  const MAGIC_LOGIN = gql`
    mutation MagicLogin($id: ID!, $code: String!, $ipAddress: String) {
      magicLogin(id: $id, code: $code, ipAddress: $ipAddress) {
        resultCode
        id
        token
        wsToken
        shardNumber
      }
    }
  `;

  const [magicLogin] = useMutation(MAGIC_LOGIN);

  const processLogin = async () => {
    try {
      const result = await magicLogin({
        variables: { id: x, code: y, ipAddress },
      });

      const { resultCode, id, token, wsToken, shardNumber } =
        result.data.magicLogin;

      if (resultCode === 4) {
        window.location = "/?message=magicLoginExpired";
        return;
      }

      if (resultCode !== 0 || !token) {
        window.location = "/?message=magicLoginFailed";
        return;
      }

      // login successfull, redirect to account's settings
      localStorage.setItem(AUTH_ID, id);
      localStorage.setItem(AUTH_TOKEN, token);
      localStorage.setItem(AUTH_WS_TOKEN, wsToken);
      localStorage.setItem(SHARD_NUMBER, shardNumber);

      if (destination && destination !== "")
        window.location = "/" + destination;
      else window.location = "/home";
    } catch (error) {
      captureException(error);
      console.log("magicLogin error", error);
      return;
    }
  };

  useEffect(() => {
    processLogin();
  }, []);

  return <LoadingPage />;
};
